module.exports = "<app-otp popup=true [otprequest]=\"temp\" (verifiedOTP)='onOTPSuccess()'></app-otp>"